import React, { useState, useEffect } from "react";
import copy_icon from "@/assets/images/ai/button/copy_icon.png";
import resend_icon from "@/assets/images/ai/button/resend_icon.png";

import "./index.less";


interface ActionBarProps {
  data: KnowledgeRetrievalOutput;
  isStreaming?: boolean;
  onResend?: (data: KnowledgeRetrievalOutput) => void;
  actions?: Array<"copy" | "resend" | "feedback">;
}
export default function ActionBar(props: ActionBarProps) {
  
  const { data, onResend, actions = ["copy", "resend"], isStreaming = false } = props;
  const [copied, setCopied] = useState(false); // 状态标志

  const copySummary = () => {
    const text = data.outputs.summary;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true); // 成功复制后，设置标志位
    });
   
  };
  const resend = () => {
    onResend?.(data);
  };

  useEffect(() => {
    if (copied) {
      window.message.success("已复制到剪切板", 2);
      setCopied(false); // 重置状态，防止重复提示
    }
  }, [copied]);


  return (
    <div className="chat-block__actions">
      {actions.includes("copy") && (
        <div className="chat-block__actions-item" onClick={copySummary}>
          <img className="chat-block__actions-item__icon" src={copy_icon} alt="" />
          <span>复制</span>
        </div>
      )}
      {actions.includes("resend") &&  !isStreaming &&  (
        <div className="chat-block__actions-item" onClick={resend}>
          <img className="chat-block__actions-item__icon" src={resend_icon} alt="" />
          <span>重新回答</span>
        </div>
      )}
    </div>
  );
}
